import Vue from 'vue'
import axios from '../../global/axios.js'
import INTERFACE from "../../assets/interface/special.js";
import {STATUSCODE} from "../../assets/js/defined.js";
import defaultCompanyPhoto from "../../assets/images/photo.png"
import { resolve } from 'url';
import { reject } from 'q';
//import { Message } from 'element-ui';
export default {
    state: {
        loginInfo: {},
        //默认分页当前显示条数
        pageRow: 5,
        currentPage: 1,
        //token
        token: '',
        id: '',
        xsrfToken: '',
        userInfo: {},
        companyInfo:{},
        tableHeight: 0,
        loadingStatus: 0,// 为0  loading关闭，否则打开
        menuList: [],//资源菜单
        asideList: [],//左侧菜单
        buttonList: [],//按钮权限
        iframeSrc: '',//三级页面地址
        openIndex: '',//默认展开的二级菜单
        activeIndex:'',
        applyModule:[],//应用下的 所有模块

        // 云投所属轮次
        financeRound:[
            {
                code:"种子轮",
                value:"种子轮"
            },
            {
                code:"天使轮",
                value:"天使轮"
            },
            {
                code:"Pre-A轮",
                value:"Pre-A轮"
            },
            {
                code:"A轮",
                value:"A轮"
            },
            {
                code:"A+轮",
                value:"A+轮"
            },
            {
                code:"B轮",
                value:"B轮"
            },
            {
                code:"B+轮",
                value:"B+轮"
            },
            {
                code:"C轮",
                value:"C轮"
            },
            {
                code:"C+轮",
                value:"C+轮"
            },
            {
                code:"D轮",
                value:"D轮"
            },
            {
                code:"D+轮",
                value:"D+轮"
            },
            {
                code:"E轮",
                value:"E轮"
            },
            {
                code:"F轮",
                value:"F轮"
            },
            {
                code:"F+轮",
                value:"F+轮"
            },
            {
                code:"战略融资",
                value:"战略融资"
            },
            {
                code:"ProIPO",
                value:"ProIPO"
            },
            {
                code:"IPO",
                value:"IPO"
            },
            {
                code:"其他",
                value:"其他"
            }
        ]
    },
    mutations: {
        setToken(state, token) {
            state.token = token;
            // Vue.localStrage.set('token', token);
            sessionStorage.setItem('zqyl-token', token);
        },
        setXsrfToken(state, token) {
            state.xsrfToken = token;
            sessionStorage.setItem('zqyl-xsrfToken', token);
        },
        setId(state, id) {
            state.id = id;
            Vue.localStrage.set('zqyl-id', id);
        },
        setLoginInfo(state, data) {
            state.loginInfo = data;
            Vue.localStrage.set('zqyl-loginInfo', JSON.stringify(data));
        },
        setUserInfo(state,data){
            // let data1={
            //     uid:data.user.id,
            //     headPhoto:data.user.headPhoto,
            //     employeeName:data.user.employeeName,
            //     authStatus:data.user.authStatus
            // };
            // state.userInfo = data1;
            sessionStorage.setItem('zqyl-info-user', JSON.stringify(data));
        },
        
        //登陆的企业信息
        setCompanyInfo(state, data) {
            state.companyInfo = data;
            Vue.localStrage.set('zqyl-info-company', JSON.stringify(data));
        },
        //一级菜单
        setMenuList(state, data) {
            state.menuList = JSON.parse(data);
        },
        
        //左侧菜单
        setAsideList(state, data) {
            state.asideList = data;
            Vue.localStrage.set('asideList', JSON.stringify(data));
        },
        //首页下按钮权限
        setButtonList(state, data) {
            state.buttonList = data;
            Vue.localStrage.set('buttonList', JSON.stringify(data));
        },
        //从首页按钮跳转三级页面
        setIframeSrc(state, data) {
            state.iframeSrc = data;
            Vue.localStrage.set('iframeSrc', data);
        },
        
        //计算表格固定高度
        setTableHeight(state) {
            var timer = setTimeout(function () {
                let searchDom = document.querySelector(".yl-search");
                let titleDom = document.querySelector(".yl-title");
                let pageDom = document.querySelector(".el-pagination");
                let tableHeaderDom = document.querySelector(".el-table__header");
                let searchDomHeight = searchDom ? searchDom.clientHeight : 0;
                let titleDomHeight = titleDom ? titleDom.clientHeight : 0;
                let pageDomHeight = pageDom ? pageDom.clientHeight : 32; //有时无法获取
                let tableHeaderDomHeight = tableHeaderDom ? tableHeaderDom.clientHeight : 0;
                if (titleDom) {
                    state.tableHeight = window.innerHeight - searchDomHeight - titleDomHeight - pageDomHeight - tableHeaderDomHeight + 25;
                }

            }, 300);
        },
        // open loading
        setLoading(state, payload) {
            // console.log("setLoading执行")
            state.loadingStatus = payload ? ++state.loadingStatus : --state.loadingStatus;
            // state.loadingStatus =  ++state.loadingStatus;
            let loading = Loading.service({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            // startLoading();  					// 开启加载
            if (state.loadingStatus == 0) {
                loading.close(); 				// 关闭加载
            }
            return state.loadingStatus;
        },
		setPageRow(state, data) {
            state.pageRow = data;
		},
    },
    getters: {
        getToken: state => {
            return state.token || sessionStorage.getItem("zqyl-token");
        },
        getXsrfToken: state => {
            return state.xsrfToken || sessionStorage.getItem("zqyl-xsrfToken");
        },
        getUserInfo: state => {
            return JSON.stringify(state.userInfo) != "{}" ? state.userInfo : JSON.parse(sessionStorage.getItem("zqyl-info-user"));
        },
        getCompanyInfo: state => {
            return JSON.stringify(state.userInfo) != "{}" ? state.userInfo : JSON.parse(Vue.localStrage.get("zqyl-info-company"));
        },
        getMenuList: state => {
            return JSON.stringify(state.menuList) != "[]" ? state.menuList : [];
        },
        getButtonList: state => {
            return JSON.stringify(state.buttonList) != "[]" ? state.buttonList : JSON.parse(Vue.localStrage.get("buttonList"));
        },
        getAsideList: state => {
            return state.asideList;
        },
        getIframeSrc: state => {
            return state.iframeSrc;
        },
       
        
    },
    actions: {
        // eslint-disable-next-line
        getNews({ commit }, data) {
            return axios.post(INTERFACE.getNews, {
                "rows": data.row || 20,
                "type": data.type || 1,
                "page": data.page || 1,
            });
        },
        checkLogin({ commit, state }, data) {
            // if (JSON.stringify(state.loginInfo) == "{}") {
            //     return axios.post(INTERFACE.ifLogin).then(res => {
            //         if (res.data.msg == 1) {
            //             let entryUrl = "#";
            //             if (res.data.type == 1) {
            //                 entryUrl = data + "/ssl/userAdmin/toEntCenter.htm";
            //             }
            //             if (res.data.type == 2) {
            //                 entryUrl = data + "/ssl/account/toEntCenter.htm?url=/zqyl-web/ssl/account/toProjectTrialA.htm";
            //             }
            //             if (res.data.type == 3) {
            //                 entryUrl = data + "/views/ssl/member/index.html";
            //             }
            //             commit("setLoginInfo", {
            //                 "photo": res.data.userHeadPhoto ? data + res.data.photoPath + res.data.userHeadPhoto : defaultCompanyPhoto,
            //                 "url": entryUrl,
            //                 "username": res.data.userName,
            //                 "userCompany": res.data.companyName || "",
            //                 "type": res.data.type,
            //                 "state": true
            //             });
            //         } else {
            //             commit("setLoginInfo", {
            //                 "state": false,
            //                 "type": 2	//默认企业
            //             });
            //         }
            //     });
            // }
            if(sessionStorage.getItem("zqyl-token")){
                if(sessionStorage.getItem("zqyl-loginInfo")){
                    let companyInfo = JSON.parse(sessionStorage.getItem("zqyl-loginInfo")).companyList;
                    commit("setLoginInfo", {
                        "photo": companyInfo.headPhoto ? companyInfo.headPhoto : defaultCompanyPhoto,
                        "url": '/platform/contain.xhtml',  //跳转路径
                        "username": '',   //用户名，接口补充参数后加
                        "userCompany": companyInfo.custName || "",
                        "type": '',  //企业信息，接口补充参数后加
                        "state": true,
                    });
                }
            }
        },
        getLoginRandom() {
            return axios.get(INTERFACE.getLoginRandom);
        },
        //获取登陆后的企业信息
        getCompany() {
            return axios.get(INTERFACE.queryUserIdBindCompanyList, {
                params: {
                    platformType: 1
                }
            })
        },
        getResource({commit , state},data){
            return axios.get(INTERFACE.queryAllFunctionList, {
                params: {
                    sourceType: 10,
                    platformType:1,   //1云信
            		facadeAppCode:"ZQYL-WEB",
                    isCurUser:1,
                    sourceCode:data?data:'',
                }
            })
        },  
        getCompanyInfo({commit},object){
            axios.get(INTERFACE.queryCompanyInfo).then(res => {
                if (res.data.status == STATUSCODE.code01) {
                    commit("getCompanyInfo",res.data.data.companyUserInfo);
                }
            }).catch(error => {
                console.log(error);
            })
        },
    }
}